export default function Profile(){
    return (
        <img 
            src="https://i.imgur.com/Up8cUQN.jpeg"
            alt="Katherine Johnson" 
            style={{ width: '150px', height: '200px' }}
        />
    )
}
